'use client'

import { useEffect } from 'react'
import { useRouter } from '@/i18n/navigation'
import { usePremium } from '@/contexts/PremiumContext'
import { ElementComparator } from '@/components/ElementComparator'
import { GitCompare, Crown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { toast } from 'react-hot-toast'
import { useTranslations } from 'next-intl'

export default function ComparePage() {
  const { isPremium } = usePremium()
  const router = useRouter()
  const t = useTranslations('Compare')

  useEffect(() => {
    if (!isPremium) {
      toast.error(t('errorPremiumOnly'))
      router.push('/premium')
    }
  }, [isPremium, router, t])

  if (!isPremium) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <Crown className="w-24 h-24 text-[#FFD700] mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-white mb-4">{t('premiumTitle')}</h1>
        <p className="text-[#a8b2d1] text-xl mb-8">{t('premiumDesc')}</p>
        <Button
          onClick={() => router.push('/premium')}
          className="bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-[#0a192f] hover:opacity-90 font-bold"
        >
          <Crown className="w-5 h-5 mr-2" />
          {t('upgradeToPremium')}
        </Button>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#0a192f] py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-block p-4 bg-[#64ffda]/10 rounded-full mb-4">
            <GitCompare size={48} className="text-[#64ffda]" />
          </div>
          <h1 className="text-5xl font-bold text-white mb-4">
            {t('title')}
          </h1>
          <p className="text-xl text-[#a8b2d1] max-w-2xl mx-auto">
            {t('subtitle')}
          </p>
        </div>

        <ElementComparator />

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="p-6 bg-[#112240] border-2 border-[#233554] rounded-xl">
            <h3 className="text-xl font-semibold text-[#64ffda] mb-3">{t('quickSearchTitle')}</h3>
            <p className="text-[#a8b2d1]">{t('quickSearchDesc')}</p>
          </div>

          <div className="p-6 bg-[#112240] border-2 border-[#233554] rounded-xl">
            <h3 className="text-xl font-semibold text-[#64ffda] mb-3">{t('detailedTitle')}</h3>
            <p className="text-[#a8b2d1]">{t('detailedDesc')}</p>
          </div>

          <div className="p-6 bg-[#112240] border-2 border-[#233554] rounded-xl">
            <h3 className="text-xl font-semibold text-[#64ffda] mb-3">{t('upTo4Title')}</h3>
            <p className="text-[#a8b2d1]">{t('upTo4Desc')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
